import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A subaccount value from the BCH subaccount summary file.
 */
export type Subaccount = string
export namespace Subaccount {
  export const isSubaccount: TypeChecker<Subaccount> = TypeChecker.isString

  /**
   * A PMS Upload subaccount code value used as a fallback payment reference.
   */
  export type Code = string
  export namespace Code {
    export const isCode: TypeChecker<Code> = TypeChecker.isString
  }
}
